// §11/D98 — Job-Titel-Ableitung (SSOT). Primär das vom prompt-enhance vergebene Titel-Signal
// (executed_pipeline_spec.signals.enhance.title; persistiert wie pack.meta/loopScore). Solange
// der Job läuft (Signale noch nicht persistiert) bzw. bei Tools ohne enhance-Knoten
// (chroma-key-remover): Fallback = gekürzter settings.prompt; sonst undefined (→ Tool-Name).
// HIER zentralisiert (D142): sowohl die Jobs-Liste (JobRow, Frontend) als auch der Server
// (Ordner-Inhalte: Input-Image + Titel je Asset) leiten den Titel aus DERSELBEN Funktion ab —
// eine Quelle, kein Drift (CLAUDE.md SSOT).

const MAX_TITLE_CODEPOINTS = 48;

/**
 * Job-Titel aus `executed_pipeline_spec` (enhance-Signal) mit `settings.prompt` als Fallback.
 * Beide Parameter sind bewusst `unknown` — der Aufrufer reicht die rohen jsonb-Felder durch
 * (Server: coerceJsonb; Frontend: das geparste JobRow-Feld). Liefert `undefined`, wenn weder
 * ein Titel-Signal noch ein nutzbarer Prompt vorliegt (→ der Aufrufer zeigt den Tool-Namen).
 */
export function deriveJobTitle(executedSpec: unknown, settings: unknown): string | undefined {
  const spec = executedSpec as { signals?: Record<string, Record<string, unknown>> } | null;
  const sig = spec?.signals?.["enhance"]?.["title"];
  if (typeof sig === "string" && sig.trim()) return sig.trim();
  const prompt = (settings as { prompt?: unknown } | null)?.prompt;
  if (typeof prompt === "string" && prompt.trim()) {
    const compact = prompt.replace(/\s+/g, " ").trim();
    // Codepoint-sicher kürzen (Codex-P2: String.slice kann Emoji-Surrogate-Paare zerreißen).
    const cps = Array.from(compact);
    return cps.length <= MAX_TITLE_CODEPOINTS ? compact : `${cps.slice(0, MAX_TITLE_CODEPOINTS - 1).join("").trimEnd()}…`;
  }
  return undefined;
}
